import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const mutationFn = ({ addressIds, stepId }) => {
  return request.post(
    'FlatsGrid/check_step_address_life_cycle',
    { addressIds, stepId },
    undefined,
    'Error',
    undefined,
    undefined,
    true
  );
};

export const useCheckRoomListStep = (options) => {
  return useMutation(mutationFn, options);
};
